<template>
	<div id="nav">
		<nav aria-label="main menu">
			<ul>
				<li>
					<router-link title="Home" to="/" @click="toggleNavBar()">Home</router-link>
				</li>
				<li
					v-if="
						(adminState?.isSiteAdmin || adminState?.isSysadmin || adminState?.isManager) &&
						adminState?.isLoggedOn &&
						adminState?.casinoId &&
						!adminState?.permissionsSuspended
					"
				>
					<router-link title="Casino Administration" to="/casinoAdministration" @click="toggleNavBar()">Casino Administration</router-link>
				</li>
				<li
					v-if="
						(adminState?.isSysadmin ||
							adminState?.isHelpDesk ||
							adminState?.isSiteAdmin ||
							adminState?.isCashier ||
							adminState?.isManager) &&
						adminState?.isLoggedOn &&
						adminState?.casinoId &&
						!adminState?.permissionsSuspended
					"
				>
					<router-link title="User Manager" to="/userManager" @click="toggleNavBar()">User Manager</router-link>
				</li>
				<!-- <li v-if="adminState?.isLoggedOn && adminState?.casinoId && adminState?.isSysadmin && !adminState?.permissionsSuspended">
					<router-link title="Mru Administration" to="/mruAdministration" @click="toggleNavBar()">Mru Administration</router-link>
				</li> -->
				<li v-if="adminState?.isLoggedOn && adminState?.isSysadmin && !adminState?.permissionsSuspended">
					<router-link title="Create/Delete Casino" to="/createOrDeleteCasino" @click="toggleNavBar()">Create/Delete Casino</router-link>
				</li>
				<li v-if="adminState?.isLoggedOn && adminState?.isSysadmin && !adminState?.permissionsSuspended">
					<router-link title="Buy-Ins Manager" to="/buyInsManager" @click="toggleNavBar()">Buy-In Offers Manager</router-link>
				</li>
				<li v-if="adminState?.casinoId && adminState?.isLoggedOn && adminState?.isSysadmin && !adminState?.permissionsSuspended">
					<router-link title="Set Progressive Limits" to="/progressiveLimits" @click="toggleNavBar()">Set Progressive Limits</router-link>
				</li>
				<li v-if="adminState?.isLoggedOn && adminState?.isSysadmin && !adminState?.permissionsSuspended">
					<router-link title="Document Manager" to="/documentManager" @click="toggleNavBar()">Document Manager</router-link>
				</li>
				<li v-if="devMode">
					<router-link title="SystemInfo" to="/systemInfo" @click="toggleNavBar()">SystemInfo</router-link>
				</li>
				<li>
					<router-link title="About" to="/about" @click="toggleNavBar()">About</router-link>
				</li>
				<li v-if="isMobile && adminState?.isLoggedOn">
					<a title="Logout" target="_blank" @click="logout()">Logout</a>
				</li>
			</ul>
			<span id="loading-icon"></span>
		</nav>
		<div class="casino-name">
			<p>{{ adminState?.casinoName }}</p>
		</div>
	</div>
</template>

<script>
export default {
	name: "MainNavbar",
	props: {
		adminState: Object,
		isMobile: Boolean,
	},
	methods: {
		toggleNavBar() {
			this.eventBus.emit("toggleNavBar");
		},
		logout() {
			this.eventBus.emit("regularLogout");
			// this.eventBus.emit("toggleNavBar");
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.casino-name {
	position: relative;
	bottom: 0;
	text-align: center;
}

#nav a {
	font-weight: bold;
	color: #2c3e50;
	/* overflow-wrap: anywhere; */
	text-overflow: ellipsis;
	overflow: hidden;
}

#nav a.router-link-exact-active {
	font-weight: normal;
	color: #fff;
}

#nav {
	position: fixed;
	top: 80px;
	left: 0;
	bottom: 0;
	max-height: 0;
	width: 100%;
	background-color: #bccfe5;
	overflow: hidden auto;
	list-style: none;
	padding: 0;
	transition: max-height 0.3s;
	z-index: 100;
	box-shadow: 0px 3px 3px rgb(0 0 0 / 50%);
}

#nav.open {
	max-height: 80vh;
}

#nav.open.dev-mode {
	max-height: 525px;
}

@media (min-width: 768px) {
	#nav {
		position: relative;
		top: unset;
		width: 20%;
		float: left;
		height: calc(100vh - 130px);
		max-height: unset;
		box-shadow: 1px 0px 6px rgb(0 0 0 / 50%);
		z-index: unset;
	}
}

#nav a {
	font-weight: bold;
}

nav ul {
	display: flex;
	flex-flow: column nowrap;
	margin: 0;
	padding: 0;
	list-style: none;
	overflow: hidden;
}

nav a {
	display: block;
	background-color: #5b88c0;
	margin: 10px;
	padding: 10px;
	border-radius: 6px;
	text-decoration: none;
	transition: 0.3s;
	color: #dceeff;
	user-select: none;
	cursor: pointer;
	box-shadow: inset -1px -1px 15px 0px rgb(0 0 0 / 40%);
}

nav a:hover,
.login-link:hover {
	transform: scale(1.025);
	background-color: #4971a4;
	color: white;
}

.router-link-active,
.router-link-active:hover {
	transform: scale(1);
	background-color: green;
	box-shadow: inset 0px 0px 14px rgb(0 0 0 / 44%);
	cursor: default;
}

.casino-name {
	color: #000;
}

@media (min-width: 768px) {
	#nav.open,
	#nav.open.dev-mode {
		max-height: unset;
	}
}
</style>
